import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { Observable, map, tap } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompleteGuard {
  private isModalOpen = false;

  constructor(
    private auth: AuthService,
    private userService: UserService,
    private dialog: MatDialog,
    private router: Router,
    private translocoService: TranslocoService
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const userId = this.auth.getCurrentUser()?.userId;
    if (!userId || state.url.startsWith('/edit-profile')) return true;

    return this.userService.isProfileComplete(userId).pipe(
      tap((complete) => {
        if (!complete) this.promptToComplete();
      }),
      map(() => true)
    );
  }

  private promptToComplete(): void {
    if (this.isModalOpen) return;
    this.isModalOpen = true;

    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('shared.profileIncomplete.title'),
          message: this.translocoService.translate('shared.profileIncomplete.message'),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('shared.modal.ok'),
          showCancel: false,
        },
      },
    };

    this.dialog.open(ConfirmationModalComponent, { data: modal, disableClose: true }).afterClosed().subscribe(() => {
      this.isModalOpen = false;
      this.router.navigateByUrl('/edit-profile');
    });
  }
}
